import { render } from "./Picturevert.vue?vue&type=template&id=ff4981cc&scoped=true"
import script from "./Picturevert.vue?vue&type=script&lang=js"
export * from "./Picturevert.vue?vue&type=script&lang=js"

import "./Picturevert.vue?vue&type=style&index=0&id=ff4981cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff4981cc"]])

export default __exports__